const isProduction = process.env.NODE_ENV === 'production'
const isTest = ['test', 'local'].includes(process.env.NODE_ENV)
const isLocal = process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'headless'

export default {
  isProduction,
  isTest,
  isLocal,
  firebase: {
    authDomain: 'ovation-v2.firebaseapp.com',
    databaseURL: 'https://ovation-v2.firebaseio.com',
    projectId: 'ovation-v2',
    storageBucket: 'ovation-v2.appspot.com',
    messagingSenderId: '690925511448'
  },
  intercom: isProduction ? 'tbu5bls0' : 'ix7dwy5j',
  apiv2: {},
  baseAppUrl: isProduction
    ? 'https://app.ovationup.com'
    : isLocal
    ? 'http://localhost:5173'
    : 'https://app-test.ovationup.com',
  surveyUrl: isProduction
    ? 'https://survey.ovationup.com'
    : isTest
    ? 'https://survey-test.ovationup.com'
    : 'http://localhost:8081',
  api: isProduction
    ? 'https://apis.ovationup.com/app/v1'
    : isTest || isLocal
    ? 'https://sandbox-apis.ovationup.com/app/v1'
    : 'http://localhost:3000/app/v1',
  apiApp: isProduction ? 'https://api.ovationup.com' : 'https://api-test.ovationup.com',
  apiReporting: isProduction
    ? 'https://api-server.ovationup.com'
    : 'https://api-server-test.ovationup.com',
  pusherKey: isProduction ? '62a99c67f775a7c4f82e' : 'dd306af8edb6cf0d4b45',
  sandboxApi: 'https://sandbox-apis.ovationup.com/app/v1',
  websocketApi: isProduction
    ? 'wss://jbt2yh7xsc.execute-api.us-east-1.amazonaws.com/production'
    : 'wss://bj78p558jb.execute-api.us-east-1.amazonaws.com/sandbox',
  icons: {
    ovation: '/img/icons/ovation-icon.png'
  },
  assetsUrl: 'https://assets.ovationup.com/'
}
